import React from "react";

function BulbIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
    >
      <g clip-path="url(#clip0_2012_28144)">
        <path
          d="M9.5625 13.75C9.9 12.6285 10.5996 11.6723 11.2922 10.7195C11.475 10.4699 11.6578 10.2203 11.8336 9.96719C12.5297 8.96523 12.9375 7.75234 12.9375 6.44102C12.9375 3.02031 10.1672 0.25 6.75 0.25C3.33281 0.25 0.5625 3.02031 0.5625 6.4375C0.5625 7.74883 0.970313 8.96523 1.66641 9.96367C1.84219 10.2168 2.025 10.4664 2.20781 10.716C2.90391 11.6688 3.60352 12.6285 3.9375 13.7465H9.5625V13.75ZM6.75 18.25C8.30391 18.25 9.5625 16.9914 9.5625 15.4375V14.875H3.9375V15.4375C3.9375 16.9914 5.19609 18.25 6.75 18.25ZM3.9375 6.4375C3.9375 6.74687 3.68438 7 3.375 7C3.06562 7 2.8125 6.74687 2.8125 6.4375C2.8125 4.26133 4.57383 2.5 6.75 2.5C7.05937 2.5 7.3125 2.75312 7.3125 3.0625C7.3125 3.37188 7.05937 3.625 6.75 3.625C5.19609 3.625 3.9375 4.88359 3.9375 6.4375Z"
          fill="#28A745"
        />
      </g>
      <defs>
        <clipPath id="clip0_2012_28144">
          <path d="M0 0.25H13.5V18.25H0V0.25Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BulbIcon;
